export enum EventTypes {
  PARADA = "Parada",
  DESCARREGAMENTO_INDEVIDO = "Descarregamento indevido",
  EXCESSO_DE_VELOCIDADE = "Excesso de velocidade",
  BLOQUEIO = "Bloqueio de veículo",
  VENCIMENTO_DO_CONCRETO = "Vencimento do concreto",
  MANUTENCAO = "Manutenção de veículo",
  DESCARREGAMENTO_POTENCIAL = "Descarregamento potencial",
  EXCESSO_DE_VELOCIDADE_VIAGEM = "Excesso de velocidade definido para a viagem",
  JAMMING_DETECTADO = "Evento de Jammer",
  ZMRC = "ZMRC",
  ENTRADA_EM_LOCAL_CONFIAVEL = "Entrada em local confiável",
  ABASTECIMENTO_COMBUSTIVEL = "Abastecimento de combustível",
  QUEDA_BRUSCA_COMBUSTIVEL = "Queda brusca de combustível",
  EXCESSO_DE_TEMPERATURA = "Excesso de temperatura"
}

export enum EventTypesID {
  PARADA = "05f6912f-e8d7-45ed-9221-232461285e20",
  DESCARREGAMENTO_INDEVIDO = "6d9d85ff-32f2-4fe7-a40e-0460a543000c",
  EXCESSO_DE_VELOCIDADE = "851dc10c-9a70-42dd-8f50-839e92e8acf0",
  BLOQUEIO = "6cdc4ea0-7667-11ed-a1eb-0242ac120002",
  VENCIMENTO_DO_CONCRETO = "827ece16-e505-49eb-a66e-c8fff9ba2cb2",
  MANUTENCAO = "767850d8-941d-426b-9dc6-a8e86110db34",
  DESCARREGAMENTO_POTENCIAL = "7f267e45-6dbe-4cf9-8733-a72afec72786",
  EXCESSO_DE_VELOCIDADE_VIAGEM = "8b914ae4-d7c8-404a-add1-ada6a50fb0a6",
  JAMMING_DETECTADO = "20204d7a-e4fe-47af-8ff6-187bca92f3a3",
  ZMRC = "a7a1f448-aadb-4116-bc72-254f8d591ac5",
  ENTRADA_EM_LOCAL_CONFIAVEL = "22ca63a8-d421-4de0-be9f-8599438d271e",
  ABASTECIMENTO_COMBUSTIVEL = "8091ec8d-889f-4515-a754-815e144ecb78",
  QUEDA_BRUSCA_COMBUSTIVEL = "4af2ab3d-9e6e-4cd1-a261-39316ed26d0a",
  EXCESSO_DE_TEMPERATURA = "b5d9f6a3-2c84-4e7b-9a16-8d3c5e2f7b4a"
}
